import { Table } from '@/components/accessory/table'
import { Accordion } from '../accordion'
interface Props {
  id: string
}

export const EditAccessories = ({ id }: Props) => {
  return (
    <>
      <div className="py-6">
        <Accordion title="Accessories" defaultOpen>
          <Table filters={ { assetTypeIdEq: id } } createable deleteable />
        </Accordion>
      </div>
      <Accordion title="Accessory to">
        <Table filters={{ accessoryIdEq: id }} />
      </Accordion>
    </>

  )
}
